import { atom } from 'jotai'

export const telephoneRangAtom = atom<boolean>(false)
